var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepositYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2867",
    "data-name": "Group 2867",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.656,
    height: 19.656,
    viewBox: "0 0 19.656 19.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M0,0H19.656V19.656H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M15.1,6.276h2.457a.819.819,0,0,1,.819.819v9.828a.819.819,0,0,1-.819.819H2.819A.819.819,0,0,1,2,16.923V3.819A.819.819,0,0,1,2.819,3H15.1ZM3.638,7.914V16.1h13.1V7.914Zm0-3.276V6.276h9.828V4.638Zm9.009,6.552H15.1v1.638H12.647Z",
    transform: "translate(-0.362 -0.543)",
    fill: "#f5ca3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositYellow);
export default __webpack_public_path__ + "static/media/deposit-yellow.f08ec15eda2c7faeb57fe79e4541507e.svg";
export { ForwardRef as ReactComponent };